var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: { name: "leave-group", width: 0 },
      on: { "before-open": _vm.beforeOpen }
    },
    [
      _c(
        "div",
        { staticClass: "modal modal__sphir_Online_Access_Agreement show" },
        [
          _c(
            "section",
            {
              directives: [
                {
                  name: "click-outside",
                  rawName: "v-click-outside",
                  value: _vm.hide,
                  expression: "hide"
                }
              ]
            },
            [
              _c("a", { staticClass: "modal__close" }, [
                _c("i", { staticClass: "icon-close", on: { click: _vm.hide } })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "text__center margin-b__20" }, [
                _c("b", [_vm._v("Leave Sphir?")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "text__center" }, [
                _vm._v(
                  "\n                Are you sure you want to leave this event?\n            "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "text__center" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn__reset margin-r__10",
                    on: { click: _vm.hide }
                  },
                  [
                    _vm._v(
                      "\n                    Oops! I'll stay.\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("button", { staticClass: "btn btn__m btn__round" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("BUTTON.YES")) +
                      "\n                "
                  )
                ])
              ])
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }